module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/rectangleConversionS_UB.d9a22867.svg";